/**
 * Logs message into console if proper UTM set to truthy value.
 * @param {object} - Configuration with log details.
 * @param {('log'|'warn'|'error'|'info'|'table')} [type = 'log'] - Type of console, if not specified defaults to "log".
 * @param {string | number} [subName] - additional service name subtype, can be used to log error code number
 * @param {unknown[]} [messages] - Data to be displayed as in console.
 */
const log = (config, type = 'log', subName, ...messages) => {
    const { name, fColor, bColor } = config;
    const style = `display: inline-block; color: ${fColor}; background: ${bColor}; padding: 1px 4px; border-radius: 3px;`;
    const badge = `%c${name}${subName ? ' ' + subName : ''}`;
    if (type === 'table' && messages.length === 1) {
        // print data in table, badge in the separate log
        console.log(badge, style);
        console.table(messages[0]);
    }
    else if (type === 'table' && messages.length === 2) {
        // print data in table, badge and message in the separate log
        console.log(badge, style, messages[0]);
        console.table(messages[1]);
    }
    else {
        // print any messages with a badge
        console[type](badge, style, ...messages);
    }
};
export { log };
